import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

// wrapped in React.memo below; `onChange` must be stable (useCallback in the
// parent) and `label`/`preference` are constants, so the default shallow
// comparison only re-renders this checkbox when its `checked` value changes.
function CheckBoxItem({ checked, label, preference, onChange }) {
  return (
    <FormControlLabel
      control={
        <Checkbox checked={checked} onChange={e => onChange(e, preference)} />
      }
      label={label}
    />
  );
}

CheckBoxItem.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string,
  preference: PropTypes.string,
  onChange: PropTypes.func
};

export default React.memo(CheckBoxItem);
